import React, { memo, useMemo, SyntheticEvent } from 'react';

import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import useLocales from 'src/hooks/useLocales';

import { SLIDER_MARKS } from '../constants/elementSettingsConstants';
import { FormElementValidationType } from '../../../../../@types/forms/enums/FormElementValidationType';
import {
  ELEMENT_IS_EMAIL,
  ELEMENT_IS_NUMBER,
  ELEMENT_NO_VALIDATION,
  ElementValidationsProps,
  ELEMENT_NUMBER_OF_CHARACTERS,
} from '../../../../../@types/forms/constants/ElementValidations';

type ElementValidationSettingsProps = {
  validation: ElementValidationsProps;
  numberOfCharacters: number[];
  onValidationChange: (validation: ElementValidationsProps) => void;
  onNumberOfCharactersChange: (event: Event, newValue: number | number[]) => void;
};

const ElementValidationSettings: React.FC<ElementValidationSettingsProps> = ({
  validation,
  numberOfCharacters,
  onValidationChange,
  onNumberOfCharactersChange,
}) => {
  const { t } = useLocales();

  const validationOptions = useMemo(
    () => [
      ELEMENT_NO_VALIDATION,
      ELEMENT_IS_NUMBER,
      ELEMENT_IS_EMAIL,
      ELEMENT_NUMBER_OF_CHARACTERS,
    ],
    []
  );

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} id="fYWH5ui">
        <Autocomplete
          size="small"
          value={validation}
          disableClearable
          getOptionLabel={(option) => t(option.label)}
          onChange={(
            event: SyntheticEvent<Element, Event>,
            newValue: ElementValidationsProps | null
          ) => {
            if (newValue) {
              onValidationChange(newValue);
            }
          }}
          options={validationOptions}
          renderInput={(params) => (
            <TextField {...params} label={t('forms.validations.validation')} />
          )}
        />
      </Box>

      {validation.value === FormElementValidationType.NumberOfCharacters && (
        <Box id="fYWH5ui">
          <Slider
            value={numberOfCharacters}
            onChange={onNumberOfCharactersChange}
            marks={SLIDER_MARKS}
            valueLabelDisplay="auto"
            min={1}
            max={100}
            size="medium"
          />
        </Box>
      )}
    </>
  );
};

export default memo(ElementValidationSettings);
